var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMateriaisViaVitrine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.68,
    height: 23.112,
    viewBox: "0 0 20.68 23.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "materiais-via-vitrine",
    transform: "translate(-7.097 -4.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1455",
    "data-name": "Caminho 1455",
    d: "M10.418,27.281H24.456a3.337,3.337,0,0,0,3.317-3.493L27.1,10.652a.828.828,0,0,0-.066-.2L25.921,8.7a1.281,1.281,0,0,0-1.2-.579l.074-.348A1.242,1.242,0,0,0,23.881,6.3L19.818,5.271a1.248,1.248,0,0,0-1.512.894L18.04,7.187l-.458.115-.135-1.611A1.669,1.669,0,0,0,15.6,4.179L11.1,4.7A1.669,1.669,0,0,0,9.646,6.563l.206,1.573a.872.872,0,0,0-.843.406L7.867,10.461a.935.935,0,0,0-.056.19L7.1,23.78a3.337,3.337,0,0,0,3.317,3.5ZM24.543,8.95h.326a.414.414,0,0,1,.351.193l.706,1.115H24.265ZM19.109,6.374a.416.416,0,0,1,.5-.3l4.063,1.032a.414.414,0,0,1,.3.489l-.565,2.66h-2.5L20.34,7.9a1.234,1.234,0,0,0-1.386-.93Zm-.08,1.421a.418.418,0,0,1,.5.3l.53,2.159H13.846c-.075-.393-.44-1.018.118-1.191ZM10.64,5.838a.827.827,0,0,1,.557-.316L15.7,5a.843.843,0,0,1,.922.756l.146,1.747-3,.754a1.368,1.368,0,0,0-.775,2h-2.02l-.5-3.8a.828.828,0,0,1,.171-.617ZM9.722,8.967h.238l.169,1.291H8.954ZM7.931,23.825l.688-12.737s17.666,0,17.669,0l.656,12.743a2.491,2.491,0,0,1-2.488,2.62H10.418a2.5,2.5,0,0,1-2.488-2.626Z",
    transform: "translate(0 0)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1456",
    "data-name": "Caminho 1456",
    d: "M21.6,26.553v1.631a3.145,3.145,0,0,0,6.29,0V26.553a1.177,1.177,0,1,0-.708,0v1.631a2.437,2.437,0,0,1-4.875,0V26.553a1.18,1.18,0,1,0-.708,0Zm5.936-1.593a.473.473,0,1,1-.473.473.473.473,0,0,1,.473-.473Zm-5.582,0a.473.473,0,1,1-.473.473.473.473,0,0,1,.473-.473Z",
    transform: "translate(-7.31 -10.974)",
    fill: "#640000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMateriaisViaVitrine);
export default __webpack_public_path__ + "static/media/materiais-via-vitrine.fce1e84f53071278677e364db903a340.svg";
export { ForwardRef as ReactComponent };